module.exports = __webpack_public_path__ + "img/telephone-plus-fill.ea463f62.svg";